import { IPersonaProps } from "@fluentui/react";
import {
  SharePointInputTypes,
  SharePointMetadataBooleans,
  SharePointFormatTypes
} from "../../../../config/sharepointConstants";
import { boundField } from "../../../../redux/models/reduxModels";
import { InputEnum } from "../../../enums/NormalInputTypeEnum";
import { IAllInputProps } from "../../../../interfaces/advancedSearch/IAllInputProps";
import { ClientTypeContext } from "../../../helpers/dataSourceFieldHelper";
import { DataSourceInputFactory } from "./DataSourceInputFactory";
import { ISharepointSearchInput } from "../../../../interfaces/advancedSearch/ISharepointSearchInput";

export class InputTypeFactory extends DataSourceInputFactory {
  private multiTypes = [InputEnum.peoplePickerMultiple, InputEnum.taxonomyDouble, InputEnum.lookupMulti];
  getInputType(metadata: any, boundedFields: boundField[]): InputEnum {
    if (!metadata) return InputEnum.Text;

    const datasourceType = this.getSharepointDatasourceType(metadata, boundedFields);
    if (datasourceType) return datasourceType;

    const controlType = metadata.ResultType ?? metadata.Type;
    switch (true) {
      case controlType === SharePointInputTypes.text: {
        return InputEnum.Text;
      }
      case controlType === SharePointInputTypes.number && !metadata.Percentage: {
        return InputEnum.Number;
      }
      case controlType === SharePointInputTypes.number && metadata.Percentage === SharePointMetadataBooleans.true: {
        return InputEnum.Percentage;
      }
      case controlType === SharePointInputTypes.currency: {
        return InputEnum.Currency;
      }
      case controlType === SharePointFormatTypes.dateOnly: {
        return InputEnum.Date;
      }
      case controlType === SharePointFormatTypes.dateTime: {
        return InputEnum.Date;
      }
      case controlType === SharePointInputTypes.note && +metadata.NumLines > 0: {
        return InputEnum.Text;
      }
      case controlType === SharePointInputTypes.Boolean: {
        return InputEnum.YesNo;
      }
      case controlType === SharePointInputTypes.url && metadata.Format === SharePointFormatTypes.hyperlink: {
        return InputEnum.Text;
      }
      case controlType === SharePointInputTypes.url && metadata.Format === SharePointFormatTypes.image: {
        return InputEnum.Text;
      }
      case metadata.Type === SharePointInputTypes.user: {
        return InputEnum.peoplePickerSingle;
      }
      case metadata.Type === SharePointInputTypes.userMulti: {
        return InputEnum.peoplePickerMultiple;
      }
      case metadata.Type === SharePointInputTypes.taxonomyFieldType: {
        return InputEnum.taxonomySingle;
      }
      case metadata.Type === SharePointInputTypes.taxonomyFieldTypeMulti: {
        return InputEnum.taxonomyDouble;
      }
      case metadata.Type === SharePointInputTypes.choice &&
        (metadata.Format === SharePointFormatTypes.dropdown ||
          metadata.Format === SharePointFormatTypes.radioButtons): {
          return InputEnum.choice;
        }
      case metadata.Type === SharePointInputTypes.multiChoice: {
        return InputEnum.multiChoice;
      }
      case metadata.Type == SharePointInputTypes.lookupMulti: {
        return InputEnum.lookupMulti
      }
      case metadata.Type == SharePointInputTypes.lookupSingle: {
        return InputEnum.lookupSingle
      }
      default: {
        return InputEnum.Text;
      }
    }
  }

  getInfo(
    fieldInfo: any,
    type: InputEnum,
    searchInputData: ISharepointSearchInput,
    loadPeople: () => Promise<IPersonaProps[]>,
    handleValueChange: (index: number, value: any) => void,
    selectedSites: string[],
    selectedLibraries: string[],
    clientTypes: ClientTypeContext
  ): IAllInputProps {

    const result = {
      choices: fieldInfo.Choices,
      displayName: fieldInfo.xml.DisplayName,
      documentLibrary: fieldInfo.documentLibrary,
      sharepointListId: fieldInfo.sharePointListId,
      internalName: fieldInfo.InternalName,
      itemLimit: this.multiTypes.some(item => item === type) ? 99 : 1,
      webUrl: fieldInfo.webUrl,
      min: fieldInfo.xml.Min,
      max: fieldInfo.xml.Max,
      userSelectionScope: type === InputEnum.peoplePickerSingle ? "0" : fieldInfo.xml.UserSelectionScope,
      handleValueChange: handleValueChange,
      searchInputData: searchInputData,
      loadPeople: loadPeople,
      listId: fieldInfo.xml?.List?.replace(/{|}/g, ''),
      columnInternalName: fieldInfo.xml?.ShowField,
      selectedSites,
      selectedLibraries,
      clientTypes
    };

    return result;
  }
}
